import React, { useState } from 'react';
import { Filter, X } from 'lucide-react';

export default function SegmentFilter({ availableSegments, activeSegments, onSegmentToggle }) {
  const [expandedSection, setExpandedSection] = useState('roles');

  const renderSegmentChip = (type, value) => {
    const isActive = activeSegments?.some(s => s?.type === type && s?.value === value);
    
    return (
      <button
        key={`${type}-${value}`}
        onClick={() => onSegmentToggle({ type, value })}
        className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
          isActive
            ? 'bg-blue-600 text-white hover:bg-blue-700' :'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
      >
        {value}
        {isActive && <X size={14} className="inline ml-1" />}
      </button>
    );
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Filter size={20} className="text-gray-700" />
        <h3 className="text-lg font-semibold text-gray-900">Segment Filters</h3>
        {activeSegments?.length > 0 && (
          <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
            {activeSegments?.length} active
          </span>
        )}
      </div>

      <div className="space-y-4">
        {/* User Roles */}
        <div>
          <button
            onClick={() => setExpandedSection(expandedSection === 'roles' ? null : 'roles')}
            className="flex items-center justify-between w-full mb-2"
          >
            <span className="text-sm font-medium text-gray-700">User Roles</span>
            <span className="text-xs text-gray-500">
              {availableSegments?.roles?.length || 0} available
            </span>
          </button>
          {expandedSection === 'roles' && (
            <div className="flex flex-wrap gap-2">
              {availableSegments?.roles?.map(role => 
                renderSegmentChip('role', role)
              )}
            </div>
          )}
        </div>

        {/* Artist Types */}
        <div>
          <button
            onClick={() => setExpandedSection(expandedSection === 'artistTypes' ? null : 'artistTypes')}
            className="flex items-center justify-between w-full mb-2"
          >
            <span className="text-sm font-medium text-gray-700">Artist Types</span>
            <span className="text-xs text-gray-500">
              {availableSegments?.artistTypes?.length || 0} available
            </span>
          </button>
          {expandedSection === 'artistTypes' && (
            <div className="flex flex-wrap gap-2">
              {availableSegments?.artistTypes?.map(type => 
                renderSegmentChip('artist_type', type)
              )}
            </div>
          )}
        </div>

        {/* User Status */}
        <div>
          <button
            onClick={() => setExpandedSection(expandedSection === 'statuses' ? null : 'statuses')}
            className="flex items-center justify-between w-full mb-2"
          >
            <span className="text-sm font-medium text-gray-700">User Status</span>
            <span className="text-xs text-gray-500">
              {availableSegments?.statuses?.length || 0} available
            </span>
          </button>
          {expandedSection === 'statuses' && (
            <div className="flex flex-wrap gap-2">
              {availableSegments?.statuses?.map(status => 
                renderSegmentChip('status', status)
              )}
            </div>
          )}
        </div>
      </div>

      {/* Clear All Filters */}
      {activeSegments?.length > 0 && (
        <button
          onClick={() => activeSegments?.forEach(segment => onSegmentToggle(segment))}
          className="mt-4 text-sm text-blue-600 hover:text-blue-700 font-medium"
        >
          Clear all filters
        </button>
      )}
    </div>
  );
}